import React from 'react';
import './social.scss';
import '../NAV/navigationBar.css';
const Social = () => {
	return (
		<div>
			<div
				align="center"
				className="socialbtns">
				<ul className="social-container">
					<li>
						<a
							href="https://github.com/RehamCodes"
							className="fa fa-lg fa-github"></a>
					</li>

					<li>
						<a
							href="https://www.linkedin.com/in/reham-al-khamiasi-756b2322a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
							className="fa fa-lg fa-linkedin"></a>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Social;
